import DiagnosticsPage from '@fhs-legacy/frontend/src/pages/diagnostics';
export { ErrorBoundary } from '@fhs/routing/src/components/page-dev-error-boundary';

export default DiagnosticsPage;
